// Jetpack / WordPress.com Stats tracker for the headless SPA.
//
// Since the site became a decoupled React app served by Vercel, WordPress no
// longer renders the public pages, so Jetpack's server-side beacon never fires.
// This module re-adds that beacon on the client: it loads the standard
// `stats.wp.com/e-{year}.js` script and pushes a `view` onto the `_stq` queue
// for each page. The loader turns every `view` into a `pixel.wp.com/g.gif`
// request that includes `document.referrer`, restoring both view counts and
// referrer reporting in the existing Jetpack dashboard.

// Numeric WordPress.com blog ID for the Jetpack-connected site.
// Set REACT_APP_JETPACK_BLOG_ID in the Vercel environment (baked at build time).
const BLOG_ID = process.env.REACT_APP_JETPACK_BLOG_ID;

let scriptInjected = false;

function ensureScript() {
  if (scriptInjected || typeof window === 'undefined') return;
  scriptInjected = true;

  window._stq = window._stq || [];

  const script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = `//stats.wp.com/e-${new Date().getFullYear()}.js`;
  document.head.appendChild(script);
}

// Record a single page view with Jetpack. Safe to call on every route change.
// No-ops when no blog ID is configured (e.g. local/dev builds) or off-browser.
export function recordJetpackView() {
  if (!BLOG_ID || typeof window === 'undefined') return;

  ensureScript();

  window._stq = window._stq || [];
  window._stq.push([
    'view',
    {
      v: 'ext',
      blog: BLOG_ID,
      post: '0',
      tz: '0',
      srv: window.location.hostname,
    },
  ]);
}
